// extracted by mini-css-extract-plugin
module.exports = {"slider__unit":"Slider_slider__unit__1t0Q4","slider__container":"Slider_slider__container__2YzHk","title":"Slider_title__4zDwS","container":"Slider_container__1PXej"};